// import Utf8 from "crypto-js/enc-utf8";
import { PBKDF2, AES, enc, algo } from "crypto-js";
import { encryptionKeys } from "./constants";

const PassPhrase = encryptionKeys.PassPhrase;
const SaltValue = encryptionKeys.SaltValue;
const InitVector = encryptionKeys.InitialVector;
const PasswordIterations = +encryptionKeys.PasswordIterations;
const Blocksize = +encryptionKeys.BlockSize;

// Encryption Service

export const encryptRequest = (request: any) => {
  var key = PBKDF2(PassPhrase, enc.Utf8.parse(SaltValue), {
    keySize: 256 / Blocksize,
    iterations: PasswordIterations,
    hasher: algo.SHA1,
  });
  var parsedIV = enc.Utf8.parse(InitVector);

  if (request instanceof FormData) {
    // Encrypt each text value separately inside FormData
    const encryptedFormData = new FormData();

    request.forEach((value, objKey) => {
      if (value instanceof File) {
        // Keep files unencrypted
        encryptedFormData.append(objKey, value);
      } else {
        // Encrypt text fields
        const encryptedValue = AES.encrypt(value.toString(), key, {
          iv: parsedIV,
        }).toString();
        encryptedFormData.append(objKey, encryptedValue);
      }
    });

    return encryptedFormData;
  } else {
    // Encrypt the entire object as before
    var encrypted = AES.encrypt(JSON.stringify(request), key, {
      iv: parsedIV,
    }).toString();
    return encrypted;
  }
};
// Decryption Service

export const decryptResponse = (response: any) => {
  if (!response) return "";
  try {
    var key = PBKDF2(PassPhrase, enc.Utf8.parse(SaltValue), {
      keySize: 256 / Blocksize,
      iterations: PasswordIterations,
      hasher: algo.SHA1,
    });
    var parsedIV = enc.Utf8.parse(InitVector);

    // Decrypt
    const trimmedResponse = String(response).replaceAll(" ", "");
    var bytes = AES.decrypt(trimmedResponse, key, { iv: parsedIV });
    var decryptedResponse = bytes.toString(enc.Utf8);

    if (decryptedResponse) {
      return JSON.parse(decryptedResponse);
    } else {
      return decryptedResponse;
    }
  } catch (error) {
    console.error("Decryption failed:", error);
    return "";
  }
};
